import { Batch } from '../../types'
import { Database } from '../database.types'

const MAX_STORED_ITEMS = 200

export class MemoryStorage implements Database {
  #items: Batch[]
  #maxItems: number

  constructor(maxItems = MAX_STORED_ITEMS) {
    this.#items = []
    this.#maxItems = maxItems
  }

  async reset(): Promise<void> {
    this.#items = []
  }

  async setItem(item: Batch): Promise<void> {
    this.#items.push(item)

    if (this.#items.length > this.#maxItems) {
      this.#items.splice(0, this.#items.length - this.#maxItems)
    }
  }

  getItem(id: string): Promise<Batch> {
    throw new Error('Method not implemented.' + id)
  }
  removeItem(id: string): Promise<void> {
    throw new Error('Method not implemented.' + id)
  }

  getAllItems() {
    const items = [...this.#items]
    this.reset()
    return Promise.resolve(items)
  }

  count(): number {
    return this.#items.length
  }
}
